import {
  API_DATA_REQUESTED,
  GRID_DATA_RECEIVED,
  OBSTACLES_DATA_RECEIVED,
  GEOFENCE_DATA_RECEIVED,
  SELECT_MISSION,
  UPDATE_INSPECTOR,
  CLOSE_INSPECTOR
} from 'actions/actionTypes';

const defaultState = {
  loading: false,
  grid: {},
  obstacles: {},
  geofence: {},
  selectedMission: '',
  inspector: {
    formatter: '',
    date: '',
    origin: { x: 0, y: 0 },
    open: false
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case API_DATA_REQUESTED:
      return {
        ...state,
        loading: true
      };
    case GRID_DATA_RECEIVED: {
      return {
        ...state,
        grid: action.payload,
        loading: false
      };
    }
    case OBSTACLES_DATA_RECEIVED:
      return {
        ...state,
        obstacles: action.payload,
        loading: false
      };
    case GEOFENCE_DATA_RECEIVED:
      return {
        ...state,
        geofence: action.payload || {},
        loading: false
      };
    case SELECT_MISSION:
      return {
        ...state,
        selectedMission: action.payload
      };
    case UPDATE_INSPECTOR:
      return {
        ...state,
        inspector: { ...action.payload, open: true }
      };
    case CLOSE_INSPECTOR:
      return {
        ...state,
        inspector: { ...state.inspector, open: false }
      };
    default:
      return state;
  }
};
